import { Component } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldBaseComponent } from '@shared/components/forms/components/field-base';
import { FormFieldErrorComponent } from '@shared/components/forms/components/form-field-error/form-field-error.component';

@Component({
  selector: 'lib-form-checkbox',
  templateUrl: 'form-checkbox.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FormFieldErrorComponent,
  ],
})
export class FormCheckboxComponent extends FieldBaseComponent {}
